import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-813e9b5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Contact", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hotline" }, [
  /*#__PURE__*/_createTextVNode(" Study hotline: "),
  /*#__PURE__*/_createElementVNode("span", { class: "phone" }, "+49 (0)17 85 28 16 43")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Get in touch with us by sending us a quick feedback.", -1))
const _hoisted_7 = { class: "contact-form" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "bold" }, "Your Email:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "bold" }, "Your Message to us:", -1))
const _hoisted_10 = { class: "send-button" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bannerimage",
  src: "/banner.png",
  alt: "banner"
}, null, -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "content" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "a lua legatura", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hotline" }, [
  /*#__PURE__*/_createTextVNode(" Linia fierbinte pentru studii: "),
  /*#__PURE__*/_createElementVNode("span", { class: "phone" }, "+49 (0)17 85 28 16 43")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Luați legătura cu noi trimițându-ne un feedback rapid.", -1))
const _hoisted_17 = { class: "contact-form" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "bold" }, "Email-ul tau:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "bold" }, "Mesajul dvs. pentru noi:", -1))
const _hoisted_20 = { class: "send-button" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bannerimage",
  src: "/banner.png",
  alt: "banner"
}, null, -1))
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "content" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "контакт", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hotline" }, [
  /*#__PURE__*/_createTextVNode(" Гаряча лінія навчання: "),
  /*#__PURE__*/_createElementVNode("span", { class: "phone" }, "+49 (0)17 85 28 16 43")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Зв’яжіться з нами, надіславши швидкий відгук.", -1))
const _hoisted_27 = { class: "contact-form" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "bold" }, "Твоя електронна пошта:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "bold" }, "Ваше повідомлення до нас:", -1))
const _hoisted_30 = { class: "send-button" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bannerimage",
  src: "/banner.png",
  alt: "banner"
}, null, -1))

export function render(_ctx, _cache) {
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_Language = _resolveComponent("Language")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navigation),
    _createVNode(_component_Language),
    (_ctx.lang=='en')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_form, {
                ref: "contact_form",
                "label-position": "top",
                action: "#",
                model: _ctx.form,
                "label-width": "120px"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createVNode(_component_el_form_item, { prop: "email" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        autofocus: "",
                        modelValue: _ctx.form.email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.form.email) = $event)),
                        disabled: _ctx.isSending,
                        onChange: _ctx.onInput
                      }, null, 8, ["modelValue", "disabled", "onChange"])
                    ]),
                    _: 1
                  }),
                  _hoisted_9,
                  _createVNode(_component_el_form_item, { prop: "message" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        rows: "8",
                        modelValue: _ctx.form.message,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.form.message) = $event)),
                        disabled: _ctx.isSending,
                        onInput: _ctx.onInput
                      }, null, 8, ["modelValue", "disabled", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("p", _hoisted_10, [
                    (!_ctx.isFormValid && _ctx.hints.length > 0)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          type: "warning"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.hints), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _withDirectives(_createVNode(_component_el_button, {
                      type: "success",
                      class: "right",
                      disabled: !_ctx.isFormValid || _ctx.isSending,
                      loading: _ctx.isSending,
                      onClick: _ctx.onSendClick
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Send ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading", "onClick"]), [
                      [_vShow, _ctx.isFormValid]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ]),
          _hoisted_11
        ]))
      : _createCommentVNode("", true),
    (_ctx.lang=='ro')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _hoisted_15,
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_form, {
                ref: "contact_form",
                "label-position": "top",
                action: "#",
                model: _ctx.form,
                "label-width": "120px"
              }, {
                default: _withCtx(() => [
                  _hoisted_18,
                  _createVNode(_component_el_form_item, { prop: "email" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        autofocus: "",
                        modelValue: _ctx.form.email,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.form.email) = $event)),
                        disabled: _ctx.isSending,
                        onChange: _ctx.onInput
                      }, null, 8, ["modelValue", "disabled", "onChange"])
                    ]),
                    _: 1
                  }),
                  _hoisted_19,
                  _createVNode(_component_el_form_item, { prop: "message" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        rows: "8",
                        modelValue: _ctx.form.message,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.form.message) = $event)),
                        disabled: _ctx.isSending,
                        onInput: _ctx.onInput
                      }, null, 8, ["modelValue", "disabled", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("p", _hoisted_20, [
                    (!_ctx.isFormValid && _ctx.hints.length > 0)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          type: "warning"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.hints), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _withDirectives(_createVNode(_component_el_button, {
                      type: "success",
                      class: "right",
                      disabled: !_ctx.isFormValid || _ctx.isSending,
                      loading: _ctx.isSending,
                      onClick: _ctx.onSendClick
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Send ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading", "onClick"]), [
                      [_vShow, _ctx.isFormValid]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ]),
          _hoisted_21
        ]))
      : _createCommentVNode("", true),
    (_ctx.lang=='uk')
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _hoisted_25,
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_el_form, {
                ref: "contact_form",
                "label-position": "top",
                action: "#",
                model: _ctx.form,
                "label-width": "120px"
              }, {
                default: _withCtx(() => [
                  _hoisted_28,
                  _createVNode(_component_el_form_item, { prop: "email" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        autofocus: "",
                        modelValue: _ctx.form.email,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.form.email) = $event)),
                        disabled: _ctx.isSending,
                        onChange: _ctx.onInput
                      }, null, 8, ["modelValue", "disabled", "onChange"])
                    ]),
                    _: 1
                  }),
                  _hoisted_29,
                  _createVNode(_component_el_form_item, { prop: "message" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        rows: "8",
                        modelValue: _ctx.form.message,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.form.message) = $event)),
                        disabled: _ctx.isSending,
                        onInput: _ctx.onInput
                      }, null, 8, ["modelValue", "disabled", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("p", _hoisted_30, [
                    (!_ctx.isFormValid && _ctx.hints.length > 0)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          type: "warning"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.hints), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _withDirectives(_createVNode(_component_el_button, {
                      type: "success",
                      class: "right",
                      disabled: !_ctx.isFormValid || _ctx.isSending,
                      loading: _ctx.isSending,
                      onClick: _ctx.onSendClick
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Send ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading", "onClick"]), [
                      [_vShow, _ctx.isFormValid]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ]),
          _hoisted_31
        ]))
      : _createCommentVNode("", true)
  ]))
}